import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Urgence() {
  const { t } = useTranslation('reparation');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="urgence" className="bg-slate-primary py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Texte */}
          <div
            className={`transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h2 className="font-manrope font-bold text-white text-2xl md:text-3xl lg:text-4xl mb-5 leading-tight">
              {t('urgence_h2')}
            </h2>
            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-8">
              {t('urgence_text')}
            </p>
            <a
              href="tel:+14184769950"
              aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
              title="Cliquez pour appeler"
              className="inline-flex items-center gap-3 bg-urgent hover:bg-urgent-dark text-white font-bold px-7 py-4 rounded-md text-lg transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl" />
              {t('urgence_cta')}
            </a>
          </div>

          {/* Image */}
          <div
            className={`transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Close-up%20of%20water%20damaged%20ceiling%20with%20brown%20stains%2C%20leaking%20roof%20infiltration%20inside%20a%20Quebec%20home%20interior%2C%20dramatic%20lighting%20showing%20water%20damage%2C%20photorealistic%20documentary%20style%2C%20residential%20setting%2C%20Canada&width=800&height=600&seq=rep2&orientation=landscape"
                alt="Infiltration toiture plafond endommagé à Lévis — réparation urgente par couvreur RBQ"
                className="w-full h-64 md:h-80 object-cover object-top"
                loading="lazy"
                width="800"
                height="600"
                width="800"
                height="600"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}